import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { Stage } from "../../api/getStages/types";

interface StageActionMenuProps {
  stage: Stage;
  onView: (stage: Stage) => void;
  onEdit: (stage: Stage) => void;
  onDelete: (stage: Stage) => void;
}

const StageActionMenu: React.FC<StageActionMenuProps> = ({
  stage,
  onView,
  onEdit,
  onDelete,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-8 w-8 p-0 hover:bg-gray-200 transition-colors"
          variant="ghost"
        >
          <span className="sr-only">Open menu</span>
          <EllipsisVerticalIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[150px] p-2 bg-white">
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={() => onView(stage)}
        >
          View
        </DropdownMenuItem>
        <DropdownMenuItem
          className={`flex items-center px-3 py-2 text-sm transition-colors ${
            stage.isDeleted
              ? "cursor-not-allowed text-gray-400"
              : "cursor-pointer hover:bg-gray-100"
          }`}
          disabled={stage.isDeleted}
          onClick={() => !stage.isDeleted && onEdit(stage)}
          title={
            stage.isDeleted ? "Inactive stages can't be edited." : undefined
          }
        >
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          className={`flex items-center px-3 py-2 text-sm transition-colors ${
            stage.canBeDeleted
              ? "cursor-pointer text-red-600 hover:bg-gray-100"
              : "cursor-not-allowed text-gray-400"
          }`}
          disabled={!stage.canBeDeleted}
          onClick={() => stage.canBeDeleted && onDelete(stage)}
          title={
            stage.canBeDeleted
              ? undefined
              : "This stage can't be deleted — it's in use or already deleted."
          }
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default StageActionMenu;
